module.exports = __webpack_public_path__ + "media/notificationSound.feb29173.wav";